import RecentActorsIcon from '@mui/icons-material/RecentActors';
import { UserList } from './User.List';
import { UserCreate } from './User.Create';
import { UserEdit } from './User.Edit';

export default {
    list: UserList,
    create: UserCreate,
    edit: UserEdit,
    icon: RecentActorsIcon,
};
